<template>
    <div class="box">
      <div class="aside_box" @click="serach">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">

          <el-select v-model="selects" slot="prepend"  placeholder="请选择">
            <el-option label="搜索人才" value="1"></el-option>
            <el-option label="搜索职位" value="2"></el-option>
            <el-option label="搜索企业" value="3"></el-option>
            <el-option label="搜索社团"  value="4"></el-option>
          </el-select>
          
          <el-button slot="append">搜索</el-button>
        </el-input>

        <div class="hotbox">
          <div class="leftbox">热门搜索：</div>
          <div class="rightbox"
                v-for="(item, index) in hotlist"
                :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
        <div class="linebox"></div>
        <div class="classify">
          <div>
            <el-select v-model="value1"
                        placeholder="学历要求">
              <el-option v-for="item in option1"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="value2"
                        placeholder="求职状态"
                        style="margin: 0 40px">
              <el-option v-for="item in option2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="value3"
                        placeholder="求职身份">
              <el-option v-for="item in option3"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>清空搜索条件</div>
        </div>
      </div>

      <div class="content_box">
        <div class="content_child_left">
          <div>
            <img src="../../../assets/img/chuangyetuandui.png" />
            <span>创业团队</span>
          </div>
          <div @click="serach">
            <img src="/img/大学生专区.png" />
            <span>大学生专区</span>
          </div>
          <div @click="serach">
            <img src="/img/高级人才.png" />
            <span>高级人才</span>
          </div>
          <div @click="serach">
            <img src="/img/专业人才.png" />
            <span>专业人才</span>
          </div>
        </div>
        <div class="content_child_right">
          <img v-if="banner"
                :src="banner[value]?banner[value].image:''"
                @click="serach" />
        </div>
      </div>

      <div v-for="(item, index) in recomlist"
            :key="index">
        <div class="list_box">
          <div class="list_box_child"
                @click="details(item.recommend_id, item.name)">
            <div>{{ item.name }}</div>
            <div class="gen">更多&gt;</div>
          </div>

          <el-carousel :interval="5000"  arrow="always"  indicator-position="none">
            <el-carousel-item v-if="item.data.data1.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                      v-for="(item, index) in item.data.data1"
                      :key="index"
                      @click="detail(item.user_app_id)">
                      
                  <div style="width:95%;margin:10px;auto;">
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div style="width: 88%">
                        <div style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            ">
                          <div>
                            <span>{{ item.name }}</span>
                            <span class="sty">{{ item.class_name }}</span>
                            <span style="padding-right: 30px">{{
                                item.jzb_number
                              }}</span>
                          </div>
                          <div class="btn">去聊呗</div>
                        </div>
                        <div>
                          <span>{{ item.age }}岁</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.sex }}</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.education_type_str }}</span>
                          <span style="padding-left: 40px">{{ item.salary }}/天</span>
                        </div>
                        <div style="padding-top: 15px">
                          {{ item.introduce }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="item.data.data2.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                      v-for="(item, index) in item.data.data2"
                      :key="index"
                      @click="detail(item.user_app_id)">
                  <div style="width:95%;margin:10px;auto;">
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div style="width: 88%">
                        <div style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            ">
                          <span>{{ item.name }}</span>
                          <span class="sty">{{ item.class_name }}</span>
                          <span style="padding-right: 30px">{{
                              item.jzb_number
                            }}</span>
                          <div class="btn">去聊呗</div>
                        </div>
                        <div>
                          <span>{{ item.age }}岁</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.sex }}</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.education_type_str }}</span>
                          <span style="padding-left: 40px">{{ item.salary }}/天</span>
                        </div>
                        <div style="padding-top: 15px">
                          {{ item.introduce }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="item.data.data3.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                      v-for="(item, index) in item.data.data3"
                      :key="index"
                      @click="detail(item.user_app_id)">
                  <div style="width:95%;margin:10px;auto;">
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div style="width: 88%">
                        <div style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            ">
                          <span>{{ item.name }}</span>
                          <span class="sty">{{ item.class_name }}</span>
                          <span style="padding-right: 30px">{{
                              item.jzb_number
                            }}</span>
                          <div class="btn">去聊呗</div>
                        </div>
                        <div>
                          <span>{{ item.age }}岁</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.sex }}</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.education_type_str }}</span>
                          <span style="padding-left: 40px">{{ item.salary }}/天</span>
                        </div>
                        <div style="padding-top: 15px">
                          {{ item.introduce }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="item.data.data4.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                      v-for="(item, index) in item.data.data4"
                      :key="index"
                      @click="detail(item.user_app_id)">
                  <div style="width:95%;margin:10px;auto;">
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div style="width: 88%">
                        <div style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            ">
                          <span>{{ item.name }}</span>
                          <span class="sty">{{ item.class_name }}</span>
                          <span style="padding-right: 30px">{{
                              item.jzb_number
                            }}</span>
                          <div class="btn">去聊呗</div>
                        </div>
                        <div>
                          <span>{{ item.age }}岁</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.sex }}</span>
                          <span style="padding: 0 15px">|</span>
                          <span>{{ item.education_type_str }}</span>
                          <span style="padding-left: 40px">{{ item.salary }}/天</span>
                        </div>
                        <div style="padding-top: 15px">
                          {{ item.introduce }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="bannerbox">
          <img src="@/assets/image/banner.png" />
        </div>
      </div>
    </div>

</template>
  
  <script>
import { recommendlist, bannerimage } from "@/api/director/talent/index";
export default {
  data () {
    return {
      value: 0,
      input3: "",
      selects: '',
      option1: [
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "初中及以下",
        },
        {
          value: "3",
          label: "高中及以上",
        },
        {
          value: "4",
          label: "大专及以上",
        },
        {
          value: "5",
          label: "本科及以上",
        },
        {
          value: "6",
          label: "研究生及以上",
        },
        {
          value: "7",
          label: "在校大学生",
        },
        {
          value: "8",
          label: "非在校大学生",
        },
      ],
      option2: [
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "随时到岗",
        },
        {
          value: "3",
          label: "月内到岗",
        },
      ],
      option3: [
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "职场人",
        },
        {
          value: "3",
          label: "学生/应届",
        },
        {
          value: "4",
          label: "学生在校",
        },
      ],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      value1: "",
      value2: "",
      value3: "",
      hotlist: [
        "家政",
        "出纳",
        "人才资源经理",
        "机械工程师",
        "审计",
        "清洁工",
        "普工",
        "叉车司机",
        "塔吊司机",
      ],
      recomlist: [],
      banner: [],
    };
  },
  created () {
    this.getlist();
    this.getbanner();
  },
  mounted () { },
  methods: {
    //个人主页
    detail (id) {
      this.$router.push({ name: "member-index", query: { id: id } });
    },
    getbanner () {
      bannerimage({ identity: 2 }).then((res) => {
        this.banner = res.data;
      });
    },
    details (id, name) {
      this.$router.push({
        name: "member-index",
        query: { id: id, name: name },
      });
    },
    //搜索
    serach () {
      this.$router.push({ name: "search" });
    },
    getlist () {
      recommendlist().then((res) => {
        console.log(res);
        this.recomlist = res.data;
      });
    },
  },
};
  </script>
  

<style lang="scss" scoped>
::v-deep .el-select .el-input {
  width: 100px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-select .el-input__inner {
  border: none;
}


  // height: 100vh;
  .box {
    width: 1200px;
    margin: auto;
    .bannerbox {
      padding-bottom: 20px;
      img {
        width: 100%;
      }
    }
    .list_box {
      padding: 25px 0;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      margin: 20px 0;
      .list_box_child {
        width: 95%;
        padding-bottom: 20px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .gen {
          font-size: 0.1rem;
          color: #c8c8c8;
        }
      }

      .list_box_childs {
        width: 90%;
        height: 100%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        .list_box_childs_s:hover {
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }
        .list_box_childs_s {
          font-size: 0.1rem;
          width: 48.5%;
          border: 1px solid #c8c8c8;
          border-radius: 8px;
          margin-right: 10px;
          height: 143px;
          .sty {
            padding: 0 30px;
          }
          .list_flag {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn {
              width: 80px;
              height: 30px;
              border-radius: 8px;
              background-color: #4a72dd;
              color: white;
              text-align: center;
              line-height: 30px;
            }
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }
      }
    }
    .content_box {
      height: 328px;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      // margin-bottom: 30px;
      padding: 10px;
      display: flex;
      .content_child_left {
        color: white;
        margin-right: 5px;
        width: 39%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        div {
          background-color: #eeeeee;
          width: 49%;
          height: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 120px;
            height: 120px;
          }
          div:nth-child(3) {
            margin-top: 8px;
          }
          div:nth-child(4) {
            margin-top: 8px;
          }
        }
      }
      .content_child_right {
        width: 60%;
        height: 100%;
        opacity: 1;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .aside_box {
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 0px 13px rgba(0, 0 ,0, 0.15);
      border-radius: 8px;
      // margin-top: 20px;
      margin-bottom: 30px;
      padding: 20px;
      .classify {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .linebox {
        height: 2px;
        background-color: #dadada;
        margin-bottom: 20px;
      }
      .hotbox {
        margin: 20px 0;
        display: flex;
        align-items: center;
        .leftbox {
          padding-right: 20px;
        }
        .rightbox {
          color: #4c71db;
          display: flex;
          align-items: center;
          div {
            padding: 0 20px;
          }
        }
      }
    }
}
</style>
  